/**
 * @description Configuración de dolores.
 */
const colorConfigs = {
    sidebar: {
        bg: "transparent",
        color: "common.black",
        hover: {
            bg: "primary.light",
            color: "grey.400",
        },
        active: {
            bg: "primary.main",
            color: "primary.contrastText",
        },
        pannelCollapse: {
            border: "solid 1px",
            borderColor: "grey.400",
        }
    }
};

export default colorConfigs;
